import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ArrowLeftIcon } from "@radix-ui/react-icons";

export default function Topbar() {
  const navigate = useNavigate();
  const location = useLocation();

  const isHomePage = location.pathname === "/";

  return (
    <div className="sm:hidden shadow-md bg-[#2A71E8] p-5 rounded-tl-lg rounded-tr-lg rounded-bl-none rounded-br-none flex items-center">
      {!isHomePage && (
        <button
          onClick={() => navigate(-1)}
          className="text-white flex items-center justify-center p-2 rounded-full hover:bg-[#1e5bb5]"
          aria-label="Go Back"
        >
          <ArrowLeftIcon className="w-6 h-6" />
        </button>
      )}
    </div>
  );
}
